<template>
  <div>
    <v-dialog v-model="showDialog" width="800" @click:outside="closeDialog">
      <v-card outlined>
        <v-card-title>
          <span class="text-h4 mb-2">
            {{ photo.title }}
          </span>
        </v-card-title>
        <v-card-subtitle>
          by <strong>{{ photo.photographerName }}</strong>
        </v-card-subtitle>
        <v-divider class="mb-6"></v-divider>
        <v-card-text class="pb-12">
          <div class="mb-4">
            <v-img
              :src="$asa.getImageUrl(photo, 'thumb')"
              :alt="photo.title"
              width="100%"
              contain
              max-height="600px"
            >
              <template #placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular
                    indeterminate
                    color="tertiary"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </div>
          <p class="text-body-1 text-center font-weight-bold mt-6 mb-3">
            Below the sizes available for this photo
          </p>
          <v-item-group
            v-model="selectedSize"
            active-class="bluezone secondary--text"
          >
            <v-row class="mb-6" justify="center">
              <v-col
                v-for="(size, index) in sizes"
                :key="index"
                cols="12"
                md="4"
              >
                <v-item v-slot="{ active, toggle }" :value="size" dark>
                  <v-card outlined @click="toggle">
                    <v-card-title class="justify-center">
                      <span class="text-h6 font-weight-bold">
                        {{ size.size }}
                      </span>
                    </v-card-title>
                    <!-- <v-card-subtitle
                      :class="{ 'secondary--text': active }"
                      class="text-center"
                    >
                      <span class="subtitle font-weight-bold">
                        Print
                        <span v-if="size.size === 'Small'">{{
                          photo.smallPrintCounter
                        }}</span
                        ><span v-if="size.size === 'Medium'">{{
                          photo.mediumPrintCounter
                        }}</span
                        ><span v-if="size.size === 'Large'">{{
                          photo.largePrintCounter
                        }}</span>
                        of 100
                      </span>
                    </v-card-subtitle> -->
                    <v-card-text
                      :class="{ 'secondary--text': active }"
                      class="text-center"
                    >
                      <p>
                        <span class="d-block">
                          Image size (in cm):
                        </span>
                        <span class="text-body-1 font-weight-bold">
                          {{ size.width }} x {{ size.height }}
                        </span>
                      </p>
                      <p class="ma-0 text-h6 font-weight-bold">
                        US ${{ size.amount }}.00
                      </p>
                    </v-card-text>
                  </v-card>
                </v-item>
              </v-col>
            </v-row>
          </v-item-group>
          <div class="text-right">
            <p class="text-caption">
              Printed on Hahnemühle Paper<br />
              Includes Certificate of Authenticity<br />
              International Free Shipping<br />
              2 to 4 weeks delivery<br />
              <v-dialog v-model="salesTermsDialog" width="600">
                <template #activator="{ on }">
                  <span class="text-underline" v-on="on">Terms</span>
                </template>
                <v-card outlined>
                  <v-card-title class="text-h5 font-weight-bold" primary-title>
                    Print Sales Terms
                  </v-card-title>
                  <v-card-text>
                    <div class="mb-6">
                      <h2 class="text-h6 mb-2 font-weight-bold">Payment</h2>
                      <p>
                        Payment for the prints can be made online by using your
                        Visa, Visa Debit, MasterCard, Discover, JCB, American
                        Express.
                      </p>
                    </div>
                    <div class="mb-6">
                      <h2 class="text-h6 mb-2 font-weight-bold">Shipping</h2>
                      <p>
                        The prints will be shipped to you within 2 weeks from
                        the date of remittance of payment. All prints are
                        inspected, and quality checked before shipping, the
                        prints are packed in perfect condition and if the prints
                        are found damaged on arrival, a dispute with the courier
                        company shall be taken forth. If your prints arrive
                        damaged, please email us photos of the damage caused
                        within 24 hours of receiving your order.
                      </p>
                    </div>
                    <div class="mb-6">
                      <h2 class="text-h6 mb-2 font-weight-bold">Custom Duty</h2>
                      <p>
                        Customs duty (wherever applicable) will have to be borne
                        by the buyer.
                      </p>
                    </div>
                    <div class="mb-6">
                      <h2 class="text-h6 mb-2 font-weight-bold">Returns</h2>
                      <p>
                        If you are not happy with the prints you have purchased
                        please courier them back to us within 14 days, for a
                        full refund. The return shipping cost will have to borne
                        by the buyer.
                      </p>
                    </div>
                    <div class="mb-6">
                      <h2 class="text-h6 mb-2 font-weight-bold">Copyright</h2>
                      <p>
                        The copyright for the photographs in the print rests
                        with the photographer. It is a violation of copyright to
                        copy, reproduce or distribute any images from the prints
                        without a license agreement or written authorization
                        from the holder of that copyright.
                      </p>
                    </div>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text small @click="salesTermsDialog = false">
                      Close
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </p>
            <v-btn
              :disabled="!selectedSize || selectedSize.length === 0"
              :loading="processing"
              x-large
              depressed
              dark
              class="mb-6"
              @click="buyPrint"
            >
              Buy Print
            </v-btn>
          </div>
          <p class="text-left text-caption mb-0">
            <a
              href="https://stripe.com/"
              title="Stripe [opens in a new window]"
            >
              <v-img
                src="/images/stripe/powered_by_stripe@3x.png"
                alt="powered by stripe"
                height="30"
                width="138"
                contain
              />
            </a>
          </p>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="personalDetailsDialog"
      width="400"
      @click:outside="
        personalDetailsDialog = false
        processing = false
      "
    >
      <v-card outlined>
        <v-card-title class="justify-center">
          <span class="text-h6 mb-2 font-weight-bold">
            Save time now
          </span>
        </v-card-title>
        <v-card-subtitle class="text-center">
          <span class="text-body-1">
            You don't need an account to check out
          </span>
        </v-card-subtitle>
        <v-card-text>
          <v-form
            ref="form"
            v-model="personalDetailsFormValid"
            lazy-validation
            @submit.prevent="noop"
          >
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="guest.email"
                  :rules="guestEmailRules"
                  label="Your email"
                  validate-on-blur
                  outlined
                  required
                ></v-text-field>
                <v-text-field
                  v-model="guest.confirmEmail"
                  :rules="guestConfirmEmailRules"
                  label="Confirm your email"
                  validate-on-blur
                  outlined
                  required
                ></v-text-field>
                <v-btn
                  :dark="personalDetailsFormValid"
                  :light="!personalDetailsFormValid"
                  :disabled="!personalDetailsFormValid"
                  :loading="checkEmail"
                  type="submit"
                  depressed
                  block
                  large
                  class="ma-0"
                  @click="buyPrint"
                >
                  Continue
                </v-btn>
                <div class="mt-6">
                  <span class="text-caption">
                    Your email address will be used only to send you the order
                    confirmation.
                  </span>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="accountAlreadyExistDialog"
      width="400"
      @click:outside="accountAlreadyExistDialog = false"
    >
      <v-card outlined>
        <v-card-title>
          <span class="text-body-2">
            An account with your email address:
            <strong>{{ guest.email }}</strong> already exist, please login
            before proceed with your order
          </span>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-btn
                dark
                depressed
                block
                large
                class="ma-0"
                @click="setCookieAndLogin"
              >
                Login
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import findIndex from 'lodash/findIndex'
import { mapState } from 'vuex'
import types from '@/utils/types'

export default {
  name: 'ViewPrintDialog',
  data() {
    return {
      stripe: undefined,
      stripeCustomer: undefined,
      sizes: [],
      selectedSize: [],
      processing: false,
      checkEmail: false,
      accountAlreadyExistDialog: false,
      personalDetailsDialog: false,
      personalDetailsFormValid: false,
      salesTermsDialog: false,
      guest: {
        email: ''
      },
      guestEmailRules: [
        v => !!v || 'Please enter your email address',
        v =>
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            v
          ) || 'Please enter a valid email address'
      ],
      guestConfirmEmailRules: [
        v => !!v || 'Please confirm your email',
        v => v === this.guest.email || 'Your email should match'
      ]
    }
  },
  computed: {
    ...mapState({
      me: state => state.auth.user,
      photo: state => state.prints.selectedPhoto,
      showDialog: state => state.prints.showDialog
    })
  },
  watch: {
    showDialog(isVisible) {
      if (isVisible) {
        this.generateSizes()
      }
    }
  },
  async mounted() {
    this.stripe = this.$stripe.import()

    if (this.me && this.me.stripeId) {
      const stripeId = this.me.stripeId
      try {
        this.processing = true
        this.stripeCustomer = await this.$axios.$post(
          `${process.env.baseUrl}/proxy/stripe-get-customer`,
          { stripeId }
        )
      } catch (error) {
        this.$asa.appInsights('Comp: prints/ViewPrintDialog.vue - method: mounted', error)
      } finally {
        this.processing = false
      }
    }
  },
  methods: {
    generateSizes() {
      this.sizes = []
      const cpi = 2.54
      const ppi = 96
      const maxLength = 104
      const minLength = 26
      const { width, height } = this.photo
      const isLandscape = width >= height
      const ratio = isLandscape ? width / height : height / width
      const widthToCm = (width * cpi) / ppi
      const heightToCm = (height * cpi) / ppi
      const coex = this.photo.statusName === types.photo.status.elite ? 6 : 4
      let largeWidth, largeHeight

      if (isLandscape) {
        largeWidth = widthToCm > maxLength ? maxLength : widthToCm
        const largeDiff = widthToCm - largeWidth
        const gap = largeDiff / ratio
        largeHeight = heightToCm - gap
      } else {
        largeHeight = heightToCm > maxLength ? maxLength : heightToCm
        const largeDiff = heightToCm - largeHeight
        const gap = largeDiff / ratio
        largeWidth = widthToCm - gap
      }

      const largeSize = {
        w: parseInt(largeWidth),
        h: parseInt(largeHeight)
      }
      const mediumSize = this.generateResize(largeWidth, largeHeight, ratio, 50)
      const smallSize = this.generateResize(largeWidth, largeHeight, ratio, 30)

      if (
        (isLandscape && smallSize.w >= minLength) ||
        (!isLandscape && smallSize.h >= minLength)
      ) {
        this.sizes.push({
          width: smallSize.w,
          height: smallSize.h
        })
      }
      if (
        (isLandscape && mediumSize.w >= minLength) ||
        (!isLandscape && mediumSize.h >= minLength)
      ) {
        this.sizes.push({
          width: mediumSize.w,
          height: mediumSize.h
        })
      }
      this.sizes.push({
        width: largeSize.w,
        height: largeSize.h
      })

      const sizesName = ['Small', 'Medium', 'Large']
      this.sizes.map((s, i) => {
        s.size=sizesName[i]
        s.amount=parseInt(((s.width+s.height)*coex).toFixed(0))
        return s
      })
    },
    generateResize(width, height, ratio, percentage) {
      let w, h
      if (width >= height) {
        w = parseFloat(((percentage / 100) * width).toFixed(1))
        const diff = width - w
        const gap = diff / ratio
        h = parseFloat((height - gap).toFixed(1))
      } else {
        h = parseFloat(((percentage / 100) * height).toFixed(1))
        const diff = height - h
        const gap = diff / ratio
        w = parseFloat((width - gap).toFixed(1))
      }
      return {
        w,
        h
      }
    },
    closeDialog() {
      this.processing = false
      this.$store.dispatch('prints/closeDialog')
    },
    setCookieAndLogin() {
      this.$cookies.set('100asa-redirect', `/shop/prints?id=${this.photo.id}`, {
        path: '/',
        maxAge: 60 * 60 * 1, // one hour
        secure: true,
        sameSite: 'none'
      })
      this.$router.push({
        path: '/login'
      })
    },
    async buyPrint() {
      this.processing = true

      // Set Guest email if user is not logged in
      if (!this.me && !this.guest.email) {
        this.personalDetailsDialog = true
        return
      }

      let productId = this.photo.stripeProductId
      let customer

      try {
        // Check if Guest email exist before continuing
        if (!this.me && this.guest.email) {
          this.checkEmail = true
          const userExist = await this.$axios.$get(
            `${process.env.apiBaseUrl}/users/validate-user-by-email/${this.guest.email}`
          )
          this.checkEmail = false
          this.personalDetailsDialog = false
          if (userExist) {
            this.accountAlreadyExistDialog = true
            return
          }
        }

        // Create a Customer if doesn't exist on Stripe
        if (this.stripeCustomer) {
          customer = this.stripeCustomer
        } else {
          const payload = this.me
            ? { user: this.me }
            : { user: { email: this.guest.email, name: '' } }
          customer = await this.$axios.$post(
            `${process.env.baseUrl}/proxy/stripe-create-customer`,
            payload
          )
          if (this.me) {
            const user = this.me
            user.stripeId = customer.id
            await this.$store.dispatch('account/patchUserProfile', user)
            await this.$auth.fetchUser()
          }
        }

        // Create the product if doesn't exist on Stripe
        if (!productId) {
          const productData = {
            name: '100ASA Limited Edition Print',
            description: `${this.photo.title} by ${this.photo.photographerName}`,
            image: this.photo.thumbnailUrl,
            url: `https://100asa.com/photo/${this.photo.id}`,
            photoId: this.photo.id
          }
          const product = await this.$axios.$post(
            `${process.env.baseUrl}/proxy/stripe-create-product`,
            { product: productData }
          )
          productId = product.id
          const photoData = {
            data: {
              id: this.photo.id,
              stripeProductId: productId
            }
          }
          await this.$axios.$post(
            `${process.env.baseUrl}/proxy/api-set-product-id`,
            photoData
          )
        }

        // Get all prices for the Product
        const prices = await this.$axios.$get(
          `${process.env.baseUrl}/proxy/stripe-list-product-prices?product=${productId}`
        )

        // Check if price for selected product exist or create a new one
        let priceId
        const priceIndex = findIndex(prices.data, p => {
          return (
            p.metadata.photoId === this.photo.id.toString() &&
            p.metadata.size === this.selectedSize.size
          )
        })

        if (priceIndex > -1) {
          priceId = prices.data[priceIndex].id
        } else {
          const newPriceData = {
            id: productId,
            amount: this.selectedSize.amount * 100,
            nickname: `${this.photo.id} - ${this.selectedSize.size} - ${this.photo.statusName}`,
            photoId: this.photo.id,
            title: this.photo.title,
            photographer: this.photo.photographerName,
            size: this.selectedSize.size,
            width: this.selectedSize.width,
            height: this.selectedSize.height
          }
          const newPrice = await this.$axios.$post(
            `${process.env.baseUrl}/proxy/stripe-create-product-price`,
            { product: newPriceData }
          )
          priceId = newPrice.id
        }

        // Create a payment session
        const sessionData = {
          priceId,
          customer: customer.id,
          photoId: this.photo.id,
          size: this.selectedSize
        }
        const { sessionId } = await this.$axios.$post(
          `${process.env.baseUrl}/proxy/stripe-create-product-checkout-session`,
          sessionData
        )
        await this.stripe.redirectToCheckout({
          sessionId
        })
      } catch (error) {
        this.$asa.appInsights('Comp: prints/ViewPrintDialog.vue - method: buyPrint', error)
      } finally {
        this.processing = false
        this.checkEmail = false
        this.personalDetailsDialog = false
      }
    },
    noop() {}
  }
}
</script>

<style scoped>
.text-underline {
  cursor: pointer;
  text-decoration: underline;
}
</style>
